import { getRuntimeBaseUrl } from '../utils';

import packageJson from '../../package.json';

export const captcha = process.env.REACT_APP_RECAPTCHA_KEY;
//export const baseUrl = process.env.REACT_APP_API_BASE_URL;
export const baseUrl = getRuntimeBaseUrl();

export const ACCESS_KEY = process.env.REACT_APP_ACCESS_KEY;

//download agents
export const DOWNLOAD_AGENT_LINUX = `${process.env.PUBLIC_URL}/download/df-agent-installer-linux.zip`;
export const DOWNLOAD_AGENT_WINDOWS = `${process.env.PUBLIC_URL}/download/df-agent-installer-windows.zip`;
export const DOWNLOAD_AGENT_WINDOWS__WITH_JDK = `${process.env.PUBLIC_URL}/download/df-agent-installer-windows+jdk.zip`;
export const DOWNLOAD_AGENT_MACOS = `${process.env.PUBLIC_URL}/download/df-agent-installer-macOS.zip`;

export const CHECK_LICENSE_ACTIVE = process.env.REACT_APP_CHECK_LICENSE_ACTIVE;

// axios
export const headers = { 'Content-Type': 'application/json' };
// export const timeout = 5000

export const TOKEN_KEY = 'df-auth-token';
export const USERNAME_KEY = 'df-username';
export const USEREMAIL_KEY = 'df-useremail';
export const MENUS_KEY = 'df-auth-menus';

// Datafinder
export const PW1 = 'MI@mC%&Qa$ZYsS1';
// Privacy
export const PW2 = '2wdsA890DSA3apl';

export const EXPIRE = 12 * 60 * 60 * 1000; //milliseconds - 12 hours

export const EXTENSIONS = '.xlsx,.pdf,.txt,.csv,.epub,.eml,.msg,.xls,.pst,.doc,.docx,.ppt,.pptx,.html,.htm,.odt,.ods,.json,.js,.jpg,.jpeg,.png,.bpm,.jiff,.rtf';

export const VERSION = packageJson.version;